import React, { useCallback, useEffect, useMemo } from "react";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "../../redux-store";
import { Event } from "../../models";
import { useCurrentMerchantId } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      padding: "1% 2% 1% 1%",
      [theme.breakpoints.down("sm")]: {
        padding: "1%",
      },
      flexWrap: "nowrap",
    },
    buttonAdd: {
      width: "10px",
      height: "40px",
      left: "45%",
      marginTop: "0.5em",
    },
  }),
);

const useDefaultEvent = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const dispatch = useDispatch();

  const merchantId = useCurrentMerchantId();

  const merchant = useSelector(selectors.getMerchantsList).find(
    (merch) => merch._id === merchantId,
  );

  useEffect(() => {
    dispatch(actions.getMerchants.request({ merchantId }));
  }, [dispatch, merchantId]);

  const handleCreateDefaultEventDialogOpen = useCallback(() => {
    dispatch(actions.setIsCreateDefaultEventDialogOpen(true));
  }, [dispatch]);

  const event = useMemo(
    () =>
      merchant.defaultEvent
        ? new Event({
            title: merchant.defaultEvent.title,
            content: merchant.defaultEvent.content,
            imageUri: merchant.defaultEvent.imageUri,
            expiringMinutes: merchant.defaultEvent.expiringMinutes,
          })
        : undefined,
    [merchant],
  );

  return {
    styles,
    classes,
    atomicStyles,
    merchant,
    event,
    handleCreateDefaultEventDialogOpen,
  };
};

export { useDefaultEvent as default };
